import {FC} from "react";
import {TabTitle, TabBlockAside, TabP, TabTitleDark} from "../../styles";
import ImgRadar from "../../../../assets/images/metodology-radar.svg";
import ImgArrowRight from "../../../../assets/images/icon-tab-arrow-toright.svg";
import ImgVolumeWorldMarket from "../../../../assets/images/metodology-volume-world-market.svg";
import ImgMapShema from "../../../../assets/images/karta-tehnology-shema.svg";
import ImgWorldIcon from "../../../../assets/images/metodology-world-icon.svg";
import ImgDollarFlower from "../../../../assets/images/metodology-dollar-flower.svg";
import ImgDollarFlowerIcon from "../../../../assets/images/metodology-dollar-flower-icon.svg";
import ImgPotentialGrowRussia from "../../../../assets/images/metodology-potential-grow-russia.svg";
import ImgFlashIcon from "../../../../assets/images/metodology-flesh-icon.svg";
import ImgGPBLogo from "../../../../assets/images/metodology-gpb-logo.svg";
import ImgGPBLogoIcon from "../../../../assets/images/metodology-gpb-logo-icon.svg";

export const TabInfoThree: FC = () => {
  return (
    <div>
      <TabTitle style={{color: "rgba(255, 255, 255, 0.6"}}>
        Атрибуты технологий
      </TabTitle>
      <br />
      <TabBlockAside>
        <div
          style={{
            display: "flex",
            alignItems: "start",
            justifyContent: "space-between",
            gap: 20,
          }}
        >
          <div style={{width: "45%"}}>
            <img src={ImgRadar} style={{fill: "#FF0000", width: 220}} alt="" />
          </div>
          <div style={{width: "55%"}}>
            <TabTitle>Зрелость технологии в России</TabTitle>
            <TabP>Степень развития и готовности технологии в России</TabP>
            <TabTitleDark>Методология формированияи расчета</TabTitleDark>
            <TabP>
              А) Анализ публикационной и патентной активностипо кластеру в мире;
            </TabP>

            <TabP>
              Б) Анализ публикационной и патентной активностипо кластеру в
              России;
            </TabP>

            <TabP>В) Распределение кластеров по трем группам зрелости:</TabP>

            <TabP>
              <div
                dangerouslySetInnerHTML={{
                  __html: `< 33 процентиля — низкая зрелость;<br />
<= 66 процентиля — средняя зрелость;<br />
> 66 процентиля — высокая зрелость.`,
                }}
              />
            </TabP>
            <div
              style={{
                display: "flex",
                justifyContent: "start",
                alignItems: "start",
                gap: 30,
              }}
            >
              <img
                width={50}
                src={ImgArrowRight}
                alt=""
                style={{marginTop: 8}}
              />
              <div>
                <TabTitleDark>Источники</TabTitleDark>
                <TabP>
                  Открытые источники: исследования, статьи, патенты и проч.
                </TabP>
              </div>
            </div>
          </div>
        </div>
      </TabBlockAside>
      <TabBlockAside>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "start",
            gap: 50,
          }}
        >
          <div>
            <img width={50} src={ImgVolumeWorldMarket} alt="" />
          </div>
          <div style={{width: "100%"}}>
            <TabTitle>Объем мирового рынка к 2030 г.</TabTitle>
            <TabP>
              Теоретическая величина спроса на продукт или услугу в мире к 2030
              году.
            </TabP>
            <TabP>
              На Карте технологий отображается полупрозрачной областью вокруг
              технологии.Величина ее радиуса зависит от величины рынка.
            </TabP>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
                gap: 50,
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "start",
                  gap: 10,
                }}
              >
                <img src={ImgMapShema} alt="" width={30} />
                <TabP>На Карте технологий</TabP>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "start",
                  gap: 10,
                }}
              >
                <img src={ImgWorldIcon} alt="" width={30} />
                <TabP>В описании технологии и поисковых фильтрах</TabP>
              </div>
            </div>
            <TabTitleDark>Методология формирования и расчета</TabTitleDark>
            <TabP>
              Для расчета используются оценки ведущих консалтинговых компаний и
              отраслевых аналитических центров, а также оценка ДАВТ с
              индивидуально расчетной методологией для каждой технологии.
            </TabP>
            <div
              style={{
                display: "flex",
                justifyContent: "start",
                alignItems: "start",
                gap: 30,
              }}
            >
              <img
                width={50}
                src={ImgArrowRight}
                alt=""
                style={{marginTop: 8}}
              />
              <div>
                <TabTitleDark>Источники</TabTitleDark>
                <TabP>
                  Открытые источники: исследования, статьи, патенты и проч.
                </TabP>
              </div>
            </div>
          </div>
        </div>
      </TabBlockAside>
      <TabBlockAside>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "start",
            gap: 50,
          }}
        >
          <div>
            <img width={50} src={ImgDollarFlower} alt="" />
          </div>
          <div style={{width: "100%"}}>
            <TabTitle>
              Совокупный объем мировых инвестиций в стартапыза 2023-2026 гг.,
              млн долл.
            </TabTitle>
            <TabP>
              Фактическая сумма мировых инвестиций в период 2023-2026 гг.
            </TabP>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
                gap: 30,
              }}
            >
              <img src={ImgDollarFlowerIcon} alt="" width={25} />
              <TabP>В описании технологии и поисковых фильтрах</TabP>
            </div>
            <div style={{height: 10}} />
            <TabTitleDark>Методология формирования и расчета</TabTitleDark>
            <TabP>
              Сумма мировых инвестиций в рамках технологии, сделанных в период
              2023-2026 гг.
            </TabP>
            <div
              style={{
                display: "flex",
                justifyContent: "start",
                alignItems: "start",
                gap: 30,
              }}
            >
              <img
                width={50}
                src={ImgArrowRight}
                alt=""
                style={{marginTop: 8}}
              />
              <div>
                <TabTitleDark>Источники</TabTitleDark>
                <TabP>
                  Международные базы данных венчурного капитала и прямых
                  инвестиций: Pitchbook, Crunchbase.
                </TabP>
              </div>
            </div>
          </div>
        </div>
      </TabBlockAside>
      <TabBlockAside>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "start",
            gap: 50,
          }}
        >
          <div>
            <img width={50} src={ImgPotentialGrowRussia} alt="" />
          </div>
          <div style={{width: "100%"}}>
            <TabTitle>Потенциал роста технологии в России</TabTitle>
            <TabP>
              Совокупность прямых и косвенных экономических выгод, полученных в
              результате применения технологии.
            </TabP>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
                gap: 30,
              }}
            >
              <img src={ImgFlashIcon} alt="" width={25} />
              <TabP>В описании технологии и поисковых фильтрах</TabP>
            </div>
            <div style={{height: 10}} />
            <TabTitleDark>Методология формирования и расчета</TabTitleDark>
            <TabP>Многофакторный анализ, включающий:</TabP>
            <TabP style={{marginBottom: 1}}>
              А) Потенциальный объем мирового рынка;
            </TabP>
            <TabP style={{marginTop: 1}}>Б) Объем инвестиций.</TabP>
            <TabP>
              При наличии в совокупности объема мирового рынка и объема
              инвестицийна уровне «Выше среднего» (5/6 или 6/6 по сумме
              индикаторов А и Б), технологии присваивается отметка о
              потенциальном экономической эффекте.
            </TabP>
            <div
              style={{
                display: "flex",
                justifyContent: "start",
                alignItems: "start",
                gap: 30,
              }}
            >
              <img
                width={50}
                src={ImgArrowRight}
                alt=""
                style={{marginTop: 8}}
              />
              <div>
                <TabTitleDark>Источники</TabTitleDark>
                <TabP>
                  <TabP style={{marginBottom: 1}}>
                    А) Открытые источники: исследования, статьи и пр.;
                  </TabP>
                  <TabP style={{marginTop: 1}}>
                    Б) Опросы внутренних и внешних экспертов Банка.
                  </TabP>
                </TabP>
              </div>
            </div>
          </div>
        </div>
      </TabBlockAside>
      <TabBlockAside>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "start",
            gap: 50,
          }}
        >
          <div>
            <img width={50} src={ImgGPBLogo} alt="" />
          </div>
          <div style={{width: "100%"}}>
            <TabTitle>Присутствие ГПБ</TabTitle>
            <TabP>
              Технологии, в рамках которых Банк имеет соответствующие активы.
            </TabP>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
                gap: 30,
              }}
            >
              <img src={ImgGPBLogoIcon} alt="" width={25} />
              <TabP>В описании технологии и поисковых фильтрах</TabP>
            </div>
            <div style={{height: 10}} />
            <TabTitleDark>Методология формирования и расчета</TabTitleDark>
            <TabP>Сопоставление с перечнем технологических активов банка.</TabP>

            <div
              style={{
                display: "flex",
                justifyContent: "start",
                alignItems: "start",
                gap: 30,
              }}
            >
              <img
                width={50}
                src={ImgArrowRight}
                alt=""
                style={{marginTop: 8}}
              />
              <div>
                <TabTitleDark>Источники</TabTitleDark>
                <TabP>
                  <TabP style={{marginBottom: 1}}>
                    Внутренние данные Банка.
                  </TabP>
                </TabP>
              </div>
            </div>
          </div>
        </div>
      </TabBlockAside>
    </div>
  );
};
